/**
 * 可以过滤的js error
 */
export const IGNORE_ERRORS = [
    // "_promiseRejectionHandler",                          //浏览器权限相关(可忽略) or 开发手动写的promise未正确解决的（不可忽略）
    'playBackgroundMusic',
    'setKeyboardHeight is not defined',
    'WeixinJSBridge is not defined',                        // weixin js
    '__WeixinJSBridge__ is not defined',
    'openCooperationMobile is not defined',                 // mqq版本接口问题，客户端集成的mqq引擎问题
    'captured exception, need break and refresh',
    'Can\'t find variable: getFirstImage',                   // safari分享组件getAppShareInfo错误
    'Can\'t find variable: ZhihuiOS',                        // safari分享组件ZhihuiOS错误
    'Can\'t find variable: isInterceptColseEvent',           // safari分享组件isInterceptColseEvent错误
    'Can\'t find variable: _bdbox_js_315',                   // safari分享组件_bdbox_js_315错误
    'Can\'t find variable: WebViewJavascriptBridge',         // safari分享组件WebViewJavascriptBridge错误
    'Can\'t find variable: WeixinJSBridge',                  // safari分享组件WeixinJSBridge错误
    'Can\'t find variable: cloudwisePreMonitor',             // safari分享组件cloudwisePreMonitor错误
    'Can\'t find variable: CloudwiseAddEvent',               // safari分享组件CloudwiseAddEvent错误
    'Can\'t find variable: CloudHubJSBridge',                // safari分享组件CloudHubJSBridge错误
    'Can\'t find variable: getAbstract',                     // safari分享组件getAbstract错误
    'reLocateForNative is not defined',                     //
    'x5onSkinSwitch is not defined',                        //
    'URI malformed',                                        // 图片资源url不正确， 数据损坏才会出这，相对少见
    'Cannot read property \'useToast\' of undefined',         // mqq toast
    'readyToInsertImageForNativeJSBridge is not defined',   // mqq 传图bug
    'ExecuteJsInterface is not defined',                    // mqq
    'onLocalDBCallback is not defined',
    'Can\'t find variable: $',
    'OnReceiveTransparentMsg is not defined',               // 伪QQ浏览器问题
    'window.SosJSApi.onHtmlContentReport is not a function',
    'vivoNewsDetailPage.getNewsReadStatus4Vivo is not a function',
    'vivoNewsDetailPage',
    'Cannot read property \'customQbMenuShareInfo\' of undefined',
    'removeDownloadTip is not defined',
    'getShareObj is not defined',
    'mag is not defined',
    '_mz_getNextLink is not defined',
    'onLayoutChanged is not defined',
    '__wx._ready is not a function',
    'window.mttLongPressVar.tagName',
    'UpdateToken is not defined',
    'OnRoleTypeChange is not defined',
    'a is not defined',
    'ResizeObserver loop limit exceeded', // dui Dropdown组件bug，对使用无影响（https://exchangetuts.com/resizeobserver-loop-limit-exceeded-1639479845583539），暂时忽略
    'ResizeObserver loop completed with undelivered notifications.', // dui Dropdown报错，用户无感知
];
